// Desktop ilovalar — xizmat sahifasi kontenti (uz / ru)
// SEO: "desktop ilova yaratish", "kompyuter uchun dastur", "Windows dastur",
// "macOS ilova", "Electron", "Tauri", "desktop dastur narxi", "oflayn ishlaydigan dastur".

const uz = {
    meta: {
        title: "Desktop ilova yaratish — Windows va macOS uchun dastur, 35 mln so'mdan",
        description:
            "Desktop ilova yaratish 35 mln so'mdan: Windows va macOS uchun bitta koddan dastur. Oflayn ishlash, uskuna bilan bog'lanish, avtomatik yangilanish va kodni imzolash kiradi.",
        keywords: [
            "desktop ilova yaratish",
            "kompyuter uchun dastur yaratish",
            "windows uchun dastur",
            "macos ilova yaratish",
            "electron dastur",
            "tauri ilova",
            "desktop dastur narxi",
            "oflayn ishlaydigan dastur",
        ],
    },
    hero: {
        eyebrow: "Desktop ilovalar / Windows va macOS",
        h1: "Desktop ilova yaratish — Windows va macOS uchun",
        lead:
            "Kompyuterga o'rnatiladigan dastur internetsiz ham ishlaydi, printer, skaner va tarozi bilan to'g'ridan-to'g'ri bog'lanadi hamda og'ir fayllarni mahalliy diskda tez qayta ishlaydi. Biz Electron va Tauri'da quramiz: bitta koddan Windows, macOS va kerak bo'lsa Linux versiyasi chiqadi.",
        ctaPrimary: "Bepul konsultatsiya olish",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "Windows va macOS bitta koddan",
            "Oflayn rejim va mahalliy baza",
            "Avtomatik yangilanish tizimi",
            "Kod va o'rnatish fayli sizniki",
        ],
    },
    intro: {
        h: "Desktop ilova nima uchun kerak va u qachon veb-ilovadan afzal?",
        p: [
            "Bugun ko'pchilik vazifani brauzer yopadi va bu to'g'ri yondashuv. Lekin uchta holatda kompyuterga o'rnatiladigan dastur aniq yutadi: internet beqaror yoki umuman yo'q bo'lganda, dastur uskuna bilan to'g'ridan-to'g'ri gaplashishi kerak bo'lganda va ma'lumot korxona tashqarisiga chiqmasligi shart bo'lganda.",
            "Misol keltiraylik. Do'kon kassasi internet uzilganda ham chek chiqarishi kerak, fiskal modul va tarozi bilan ishlashi lozim. Laboratoriya dasturi tahlil qurilmasidan ma'lumot oladi. Dizayn yoki video bilan ishlaydigan dastur 10 gigabaytli faylni serverga yuklamasdan, joyida qayta ishlaydi. Bularning bari brauzerda yoki umuman ishlamaydi, yoki noqulay ishlaydi.",
            "Desktop ilova o'z kamchiligiga ham ega va buni ochiq aytamiz. Har bir yangilanish foydalanuvchi kompyuteriga yetib borishi kerak, shuning uchun avtomatik yangilanish tizimi majburiy. Dastur Windows va macOS'da rasmiy ishlashi uchun kod raqamli imzolanadi, aks holda tizim uni «noma'lum manba» deb bloklaydi. Bu ishlarni biz zimmamizga olamiz.",
            "Texnologiya tanlashda ikkita asosiy yo'l bor. Electron — Chromium asosidagi yechim, katta ekotizim va tez ishlab chiqish beradi, lekin o'rnatish fayli 80–150 MB atrofida bo'ladi. Tauri esa Rust asosida ishlaydi, fayl hajmi 10–20 MB'ga tushadi va operativ xotirani kamroq band qiladi. Loyihaning talabiga qarab birini tanlaymiz.",
            "Innobek desktop ilovani hech qachon yakka holda qurmaydi. Dastur odatda server va ma'lumotlar bazasi bilan sinxronlanadi, shu bilan birga veb-panel yoki mobil ilova bilan bitta API'ni bo'lishadi. Shuning uchun keyinchalik brauzer versiyasi kerak bo'lsa, tizim noldan yozilmaydi — mavjud backend ustiga yangi interfeys qo'yiladi.",
        ],
    },
    definition: {
        term: "Desktop ilova nima?",
        text:
            "Desktop ilova — kompyuterga o'rnatiladigan dastur. U operatsion tizim resurslari, mahalliy fayllar va ulangan uskunalar bilan to'g'ridan-to'g'ri ishlaydi hamda internetsiz ham vazifasini bajara oladi.",
    },
    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir tarifga standart tarzda kiradi",
        sub: "Quyidagilar keyin qo'shimcha to'lanadigan xizmat emas — bazaviy tarifda ham bor.",
        items: [
            "Bepul konsultatsiya va joriy jarayonni tahlil qilish",
            "Texnik topshiriq va funksiyalar ro'yxati",
            "Figma'da interfeys dizayni, katta ekranga moslashtirilgan",
            "Windows va macOS uchun yagona kod bazasi",
            "Mahalliy ma'lumotlar bazasi va oflayn rejim",
            "Server bilan sinxronizatsiya mexanizmi",
            "Avtomatik yangilanish (auto-update) tizimi",
            "O'rnatish fayllari: .exe va .dmg",
            "Windows va macOS uchun kodni raqamli imzolash",
            "Foydalanuvchi va administrator uchun qo'llanma",
            "Xodimlarni o'qitish va tizimga ko'chirish yordami",
            "Git repozitoriysi va kodning to'liq mulkchiligi sizda",
        ],
    },
    benefits: {
        eyebrow: "Nega kerak",
        h: "Desktop ilova biznesga nima beradi",
        sub: "Bu — sayt o'rniga emas, brauzer uddalay olmaydigan vazifalar uchun.",
        items: [
            {
                t: "Internetsiz ham ishlaydi",
                d: "Kassa, ombor va dala ob'ektlarida aloqa uzilib turadi. Desktop ilova ma'lumotni mahalliy bazaga yozadi, internet tiklanganda esa serverga avtomatik yuboradi. Ish to'xtamaydi va hech narsa yo'qolmaydi.",
            },
            {
                t: "Uskuna bilan to'g'ridan-to'g'ri aloqa",
                d: "Chek printeri, fiskal modul, tarozi, shtrix-kod skaneri, RFID o'qigich, kamera va COM/USB port orqali ulanadigan qurilmalar. Brauzerda bularning aksariyati mumkin emas yoki qo'shimcha dastur talab qiladi.",
            },
            {
                t: "Og'ir fayllar bilan tez ishlash",
                d: "Video, CAD chizmalar, katta Excel jadvallari va yuz minglab satrli hisobotlar mahalliy protsessorda qayta ishlanadi. Faylni bulutga yuklash va uni kutish bosqichi umuman qolmaydi.",
            },
            {
                t: "Ma'lumot korxonadan chiqmaydi",
                d: "Baza korxona serverida yoki xodim kompyuterida turadi. Bank, tibbiyot va davlat sektori uchun bu ko'pincha talab, tavsiya emas. Ma'lumotlar bulutga umuman yuborilmasligi ham mumkin.",
            },
            {
                t: "Klaviatura bilan tez ishlash",
                d: "Kun davomida yuzlab yozuv kiritadigan operator uchun tezlik hal qiluvchi. Global tugmalar birikmasi, raqam bloki va oyna orasidagi tez o'tish ish vaqtini sezilarli qisqartiradi.",
            },
            {
                t: "Fonda uzluksiz jarayonlar",
                d: "Ilova yopilmaganda ham hisobot yig'adi, 1C bazasidan ma'lumot oladi, fayllarni qayta ishlaydi yoki zaxira nusxa oladi. Brauzer yorlig'i yopilsa, bu jarayonlar to'xtab qoladi.",
            },
            {
                t: "Bitta kod — uchta tizim",
                d: "Electron yoki Tauri bitta kod bazasidan Windows, macOS va Linux versiyalarini chiqaradi. Har bir platforma uchun alohida jamoa va alohida byudjet talab qilinmaydi.",
            },
            {
                t: "Nazorat ostidagi yangilanish",
                d: "Avtomatik yangilanish tizimi yangi versiyani o'zi yetkazadi, lekin qachon chiqarishni siz hal qilasiz. Muhim davrda versiyani muzlatib turish yoki faqat bir guruhga sinov uchun yuborish mumkin.",
            },
        ],
    },
    audience: {
        eyebrow: "Kimlar buyurtma qiladi",
        h: "Qanaqa vazifalar uchun desktop ilova quriladi",
        sub: "Uskuna, oflayn rejim yoki og'ir hisob-kitob ishtirok etadigan holatlar.",
        items: [
            {
                t: "Kassa va savdo nuqtalari",
                d: "Chek chiqarish, fiskal modul, tarozi va skaner bilan ishlash, internetsiz savdo qilish.",
            },
            {
                t: "Ombor va inventarizatsiya",
                d: "Shtrix-kod skaneri, qabul va jo'natish hujjatlari, oflayn sanoq va keyin sinxronizatsiya.",
            },
            {
                t: "Ishlab chiqarish va laboratoriya",
                d: "Uskunadan ma'lumot yig'ish, texnologik kartalar, sifat nazorati va smena hisoboti.",
            },
            {
                t: "Buxgalteriya va moliya",
                d: "1C bazasi bilan almashinuv, katta hisobotlar, hujjatlarni ommaviy chop etish va eksport.",
            },
            {
                t: "Loyihalash va media",
                d: "CAD chizmalar, video montaj, katta rasm to'plamlari bilan mahalliy diskda ishlash.",
            },
            {
                t: "Yopiq kontur tizimlar",
                d: "Internetga ulanmagan yoki cheklangan tarmoqda ishlaydigan idora va muassasa dasturlari.",
            },
            {
                t: "Operator ish o'rni",
                d: "Call-markaz, dispetcher va ro'yxatga oluvchi uchun klaviatura bilan tez kiritish interfeysi.",
            },
            {
                t: "Ta'lim va sinov markazlari",
                d: "Imtihon dasturi: kompyuterda nazorat qilinadigan test, cheklangan tarmoq va natijani himoyalangan saqlash.",
            },
        ],
    },
    pricing: {
        eyebrow: "Narxlar",
        h: "Desktop ilova narxi — uchta tarif",
        sub: "Narx Windows va macOS versiyalari uchun birgalikda ko'rsatilgan — har bir platforma uchun alohida hisoblanmaydi.",
        note:
            "Yakuniy hisob-kitob texnik topshiriq tasdiqlangandan keyin belgilanadi. To'lov bosqichlar bo'yicha amalga oshiriladi. Kodni imzolash sertifikati (Windows uchun yiliga taxminan 200–600 dollar, Apple Developer — yiliga 99 dollar) va server xarajatlari provayderga to'g'ridan-to'g'ri to'lanadi.",
        tiers: [
            {
                name: "Start",
                tagline: "Bitta aniq vazifani yopadigan dastur",
                price: "35 000 000",
                priceNote: "so'mdan",
                term: "2–4 oy",
                best: "Bitta bo'lim yoki bitta jarayonni avtomatlashtirmoqchi bo'lganlarga",
                features: [
                    "Windows va macOS bitta koddan",
                    "Individual interfeys dizayni",
                    "Mahalliy ma'lumotlar bazasi (SQLite yoki PostgreSQL)",
                    "5–8 ta asosiy oyna va ish stsenariysi",
                    "Excel va PDF'ga eksport, chop etish",
                    "Foydalanuvchi rollari va kirish huquqlari",
                    "Avtomatik yangilanish tizimi",
                    "O'rnatish fayllari va kodni imzolash",
                    "Qo'llanma va 3 oylik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Business",
                tagline: "Uskuna va integratsiyali to'liq tizim",
                price: "70 000 000",
                priceNote: "so'mdan",
                term: "4–7 oy",
                best: "Kassa, ombor va ishlab chiqarish kabi uskuna bilan ishlaydigan jarayonlarga",
                featured: true,
                features: [
                    "Start tarifidagi hamma narsa",
                    "Uskuna integratsiyasi: printer, fiskal modul, tarozi, skaner",
                    "To'liq oflayn rejim va server bilan sinxronizatsiya",
                    "Bir nechta ish o'rni va markazlashgan boshqaruv",
                    "1C, CRM yoki ERP bilan ma'lumot almashinuvi",
                    "Veb-panel: boshqaruv uchun brauzerda hisobotlar",
                    "Murakkab hisobotlar va tahlil paneli",
                    "Harakatlar jurnali (audit log) va zaxira nusxa",
                    "Xodimlarni o'qitish va mavjud bazadan ko'chirish",
                    "Texnik hujjatlar va 6 oylik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Enterprise",
                tagline: "Yirik va yopiq kontur tizimlari uchun",
                price: "Kelishuv",
                priceNote: "asosida",
                term: "Loyihaga qarab",
                best: "Ko'p filialli, yuqori xavfsizlik talabi bo'lgan yoki maxsus uskunali korxonalarga",
                features: [
                    "Ko'p filial va markazlashgan replikatsiya",
                    "Active Directory va yagona kirish (SSO) bilan integratsiya",
                    "Maxsus uskuna uchun drayver darajasidagi modullar",
                    "Yopiq kontur: internetga chiqmasdan ishlash",
                    "Kompyuterda mahalliy sun'iy intellekt modellari",
                    "Xavfsizlik auditi va ma'lumotlarni shifrlash",
                    "Doimiy jamoa modeli va kelishilgan SLA",
                    "Korxona ichida joylashtirish (on-premise) va monitoring",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Jarayon",
        h: "Desktop ilova qanday quriladi",
        sub: "Ish bosqichlarga bo'linadi va har bosqich oxirida siz aniq natijani qabul qilib olasiz.",
        steps: [
            {
                t: "Jarayonni o'rganish",
                d: "Xodim bugun qanday ishlashini joyida ko'ramiz: qaysi qadam ko'p vaqt oladi, qaysi ma'lumot qo'lda kiritiladi, qanday uskuna ulangan. Shundan keyin texnik topshiriq yoziladi.",
                time: "1–2 hafta",
            },
            {
                t: "Texnologiya va arxitektura",
                d: "Electron yoki Tauri, mahalliy baza turi, sinxronizatsiya sxemasi va integratsiyalar tanlanadi. Bu qaror keyinchalik tezlik va xarajatga to'g'ridan-to'g'ri ta'sir qiladi.",
                time: "1 hafta",
            },
            {
                t: "Interfeys dizayni",
                d: "Oynalar Figma'da chiziladi. Desktop interfeysi mobilnikidan farq qiladi: ma'lumot zichroq joylashadi, klaviatura bilan boshqarish va bir nechta oyna bilan ishlash hisobga olinadi.",
                time: "2–4 hafta",
            },
            {
                t: "Yadro va ma'lumotlar bazasi",
                d: "Ma'lumotlar tuzilmasi, server API'si va sinxronizatsiya mantiqi quriladi. Oflayn rejimda yuzaga keladigan ziddiyatlarni hal qilish qoidalari shu bosqichda kelishiladi.",
                time: "3–5 hafta",
            },
            {
                t: "Ilovani dasturlash",
                d: "Oynalar navbat bilan yig'iladi, uskunalar ulanadi va sinovdan o'tkaziladi. Har 2–3 haftada o'rnatiladigan versiyani olib, o'z kompyuteringizda sinab ko'rasiz.",
                time: "6–14 hafta",
            },
            {
                t: "Sinov va imzolash",
                d: "Turli Windows va macOS versiyalarida, real uskuna bilan tekshiramiz. Keyin kod raqamli imzolanadi va macOS uchun Apple notarizatsiyasidan o'tkaziladi.",
                time: "2–3 hafta",
            },
            {
                t: "Joriy etish va o'qitish",
                d: "Dasturni ish o'rinlariga o'rnatamiz, eski bazadan ma'lumotni ko'chiramiz, xodimlarni o'qitamiz va birinchi haftalarda yonma-yon turib yordam beramiz.",
                time: "1–3 hafta",
            },
        ],
    },
    samples: {
        eyebrow: "Namunalar",
        h: "Biz qurgan tizimlar",
        sub: "Quyidagi loyihalarning backend va ma'lumotlar mantiqi desktop ilova uchun ham xuddi shunday quriladi.",
        cta: "Barcha loyihalarni ko'rish",
        slugs: ["elma-lms", "imtihan", "logistatrans", "firewise-app", "myyurist-app"],
    },
    faq: {
        eyebrow: "Savol-javob",
        h: "Desktop ilova bo'yicha ko'p beriladigan savollar",
        sub: "Buyurtmadan oldin eng ko'p so'raladigan savollarga qisqa javoblar.",
        items: [
            {
                q: "Desktop ilova yaratish qancha turadi?",
                a: "Narx 35 000 000 so'mdan boshlanadi. Bazaviy tarifga 5–8 ta oyna, mahalliy baza, rollar, eksport va avtomatik yangilanish kiradi. Uskuna integratsiyasi, to'liq oflayn rejim va 1C bilan almashinuv kerak bo'lsa, tarif 70 000 000 so'mdan boshlanadi. Aniq raqam texnik topshiriq tasdiqlangandan keyin belgilanadi.",
            },
            {
                q: "Windows va macOS uchun alohida to'lanadimi?",
                a: "Yo'q. Electron va Tauri bitta kod bazasidan ikkala tizim uchun versiya chiqaradi, shuning uchun narx bitta. Linux versiyasi kerak bo'lsa, u ham xuddi shu koddan yig'iladi. Farq faqat sinov va imzolashda bo'ladi, bu esa narxga sezilarli ta'sir qilmaydi. Agar sizga faqat Windows kerak bo'lsa, macOS qismini rejadan chiqarib, muddatni qisqartirish mumkin.",
            },
            {
                q: "Menga desktop ilova kerakmi yoki veb-ilova yetarlimi?",
                a: "Agar xodim brauzerda ishlay olsa va uskuna talab qilinmasa, veb-ilova arzonroq va qulayroq: o'rnatish kerak emas, yangilanish bir joyda. Desktop ilova internetsiz ishlash, printer va skaner bilan bog'lanish, og'ir fayllarni qayta ishlash yoki ma'lumotni tashqariga chiqarmaslik shart bo'lganda tanlanadi. Ko'p loyihalarda ikkisi birga quriladi: ish o'rni desktopda, boshqaruv hisobotlari esa brauzerda bo'ladi.",
            },
            {
                q: "Electron va Tauri orasidagi farq nimada?",
                a: "Electron Chromium asosida ishlaydi, ekotizimi katta va ishlab chiqish tezroq boradi, lekin o'rnatish fayli 80–150 MB atrofida. Tauri Rust'da yozilgan, fayl hajmi 10–20 MB'ga tushadi va xotirani kamroq band qiladi. Eski va kuchsiz kompyuterlar ko'p bo'lsa Tauri'ni, murakkab kutubxonalar kerak bo'lsa Electron'ni tavsiya qilamiz.",
            },
            {
                q: "Dastur internetsiz qanday ishlaydi?",
                a: "Ma'lumot kompyuterdagi mahalliy bazaga yoziladi va ilova unga tayanib ishlaydi. Aloqa tiklanganda o'zgarishlar serverga navbat bilan yuboriladi. Bir vaqtda ikki joyda o'zgargan yozuvlar uchun ziddiyatni hal qilish qoidasi oldindan kelishiladi, shuning uchun ma'lumot yo'qolmaydi. Xodim interfeysda oxirgi sinxronizatsiya vaqtini va yuborilmagan yozuvlar sonini doim ko'rib turadi.",
            },
            {
                q: "Printer, tarozi va skaner bilan ishlash mumkinmi?",
                a: "Ha, bu desktop ilovaning asosiy afzalligi. Chek printeri, fiskal modul, elektron tarozi, shtrix-kod skaneri va COM yoki USB port orqali ulanadigan qurilmalar bilan ishlaymiz. Uskunangiz hujjatlari yoki SDK'si bo'lsa, integratsiya oddiy. Noyob qurilma bo'lsa, avval kichik sinov o'tkazamiz va shundan keyin muddatni belgilaymiz — bu keyinchalik kutilmagan kechikishning oldini oladi.",
            },
            {
                q: "Yangilanishlar xodimlar kompyuteriga qanday yetadi?",
                a: "Ilovaga avtomatik yangilanish tizimi o'rnatiladi: dastur ishga tushganda yangi versiyani tekshiradi va fonda yuklab oladi. Administrator qaysi versiya chiqarilishini nazorat qiladi. Ya'ni har bir ish o'riniga borib qo'lda o'rnatish kerak bo'lmaydi. Zarur bo'lsa, yangilanishni avval bitta bo'limga chiqarib sinab ko'rish imkoni ham bor.",
            },
            {
                q: "Kodni imzolash nima uchun kerak?",
                a: "Imzolanmagan dasturni Windows SmartScreen va macOS Gatekeeper «noma'lum manba» deb ogohlantiradi yoki umuman ochmaydi. Shuning uchun kod raqamli sertifikat bilan imzolanadi va macOS uchun Apple notarizatsiyasidan o'tkaziladi. Sertifikat sizning kompaniyangiz nomiga rasmiylashtiriladi, texnik ishni esa biz bajaramiz. Imzolangan dastur xodimlarda ortiqcha ogohlantirishsiz, birinchi urinishdayoq ochiladi.",
            },
            {
                q: "Mavjud 1C yoki CRM tizimim bilan bog'lanadimi?",
                a: "Ha. 1C bilan almashinuv odatda fayl yoki veb-xizmat orqali quriladi, CRM va ERP tizimlar bilan esa API orqali. Ma'lumot ikki tomonlama yurishi mumkin: dastur mahsulot va narxni oladi, savdo hamda harakat hujjatlarini qaytaradi. Integratsiya hajmi loyiha doirasida aniqlanadi va alohida bosqich sifatida sinovdan o'tkaziladi, chunki noto'g'ri sozlangan almashinuv buxgalteriya hisobiga to'g'ridan-to'g'ri ta'sir qiladi.",
            },
            {
                q: "Ilova ishga tushgandan keyin qo'llab-quvvatlash bormi?",
                a: "Ha. Start tarifida 3 oy, Business tarifida 6 oy qo'llab-quvvatlash narxga kiradi. Bu davrda xatolar bepul tuzatiladi va xodimlar savollariga javob beramiz. Keyin oylik texnik xizmat shartnomasini taklif qilamiz: yangi Windows va macOS versiyalariga moslashtirish, zaxira nusxa nazorati va kichik o'zgarishlar.",
            },
        ],
    },
    cta: {
        h: "Jarayoningizni birga ko'rib chiqamizmi?",
        p: "Bepul konsultatsiyada vazifangizni tinglaymiz va desktop ilova kerakmi yoki veb-ilova arzonroq yopadimi — ochiq aytamiz. Keyin texnik topshiriq, aniq narx va muddatni yozma taklifda beramiz. Qo'ng'iroq qiling: +998 90 954 12 62.",
        button: "Bepul konsultatsiya olish",
        secondary: "Telegram orqali yozish",
    },
    images: [
        {
            src: "/assets/img/services/desktop-ilova-hero.webp",
            alt: "Windows va macOS uchun desktop ilova interfeysi noutbuk ekranida",
            caption: "Bitta kod bazasidan Windows va macOS uchun ikkita o'rnatish fayli yig'iladi.",
            prompt: "A clean modern desktop application interface shown on a laptop screen in a bright office, dense data table with sidebar navigation and toolbar, dark blue and white UI, photorealistic, wide angle, soft daylight, no text readable",
        },
        {
            src: "/assets/img/services/desktop-ilova-kassa.webp",
            alt: "Kassa desktop dasturi chek printeri va shtrix-kod skaneri bilan ulangan",
            caption: "Kassa ish o'rni: chek printeri, fiskal modul, tarozi va skaner bitta dasturda.",
            prompt: "Retail point of sale workstation: monitor with POS software, receipt printer printing, barcode scanner and electronic scale on the counter, shallow depth of field, realistic photo, warm store lighting",
        },
        {
            src: "/assets/img/services/desktop-ilova-oflayn.webp",
            alt: "Oflayn rejimda ishlaydigan ombor dasturi va ma'lumot sinxronizatsiyasi sxemasi",
            caption: "Aloqa uzilganda ma'lumot mahalliy bazaga yoziladi, keyin serverga sinxronlanadi.",
            prompt: "Technical illustration of offline-first data sync: a desktop computer with a local database icon, dashed connection to a cloud server, sync arrows, flat vector style, blue and teal palette, minimal, clean background",
        },
        {
            src: "/assets/img/services/desktop-ilova-electron-tauri.webp",
            alt: "Electron va Tauri texnologiyalari solishtirilgan desktop ilova arxitekturasi",
            caption: "Electron yoki Tauri — fayl hajmi va xotira talabiga qarab tanlanadi.",
            prompt: "Side by side comparison diagram of two desktop app frameworks, one box labeled heavier bundle and one labeled lighter bundle, with Windows and macOS device icons below, flat vector infographic, blue accent, clean white background",
        },
    ],
    related: ["veb-ilovalar", "mobil-ilova", "erp-tizimlar", "biznes-avtomatlashtirish", "crm-tizimlar"],
};

const ru = {
    meta: {
        title: "Разработка десктопного приложения — программы для Windows и macOS, от 35 млн сум",
        description:
            "Разработка десктопного приложения от 35 млн сум: одна кодовая база для Windows и macOS. Работа офлайн, подключение оборудования, автообновление и подпись кода включены.",
        keywords: [
            "разработка десктопного приложения",
            "программа для компьютера на заказ",
            "приложение для windows",
            "приложение для macos",
            "electron разработка",
            "tauri приложение",
            "стоимость десктопного приложения",
            "программа работающая офлайн",
        ],
    },
    hero: {
        eyebrow: "Десктопные приложения / Windows и macOS",
        h1: "Разработка десктопного приложения для Windows и macOS",
        lead:
            "Программа, установленная на компьютер, работает без интернета, напрямую общается с принтером, сканером и весами и быстро обрабатывает тяжёлые файлы на локальном диске. Мы собираем приложения на Electron и Tauri: из одного кода выходят версии для Windows, macOS и при необходимости Linux.",
        ctaPrimary: "Получить бесплатную консультацию",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "Windows и macOS из одного кода",
            "Офлайн-режим и локальная база",
            "Система автообновления",
            "Код и установочный файл — ваши",
        ],
    },
    intro: {
        h: "Зачем нужно десктопное приложение и когда оно выигрывает у веб-версии",
        p: [
            "Сегодня большинство задач закрывает браузер, и это правильный подход. Но в трёх случаях программа, установленная на компьютер, выигрывает однозначно: когда интернет нестабилен или его нет вовсе, когда приложение должно напрямую общаться с оборудованием и когда данные не имеют права покидать периметр компании.",
            "Простой пример. Касса магазина обязана печатать чек даже при обрыве связи и работать с фискальным модулем и весами. Лабораторная программа снимает показания с прибора. Приложение для дизайна или видео обрабатывает файл на 10 гигабайт прямо на месте, не загружая его на сервер. В браузере всё это либо не работает, либо работает неудобно.",
            "У десктопного приложения есть и минусы, и мы говорим о них открыто. Каждое обновление должно дойти до компьютера пользователя, поэтому система автообновления обязательна. Чтобы программа официально запускалась в Windows и macOS, код нужно подписать цифровым сертификатом, иначе система пометит её как «неизвестный источник». Эту работу мы берём на себя.",
            "В выборе технологии есть два основных пути. Electron построен на Chromium, даёт большую экосистему и быструю разработку, но установочный файл получается около 80–150 МБ. Tauri работает на Rust, размер файла падает до 10–20 МБ и оперативной памяти требуется меньше. Что именно выбрать, решаем исходя из требований проекта.",
            "Innobek никогда не строит десктопное приложение в отрыве от остальной системы. Программа обычно синхронизируется с сервером и базой данных и использует общий API с веб-панелью или мобильным приложением. Поэтому, если позже понадобится браузерная версия, систему не придётся писать заново — новый интерфейс ляжет поверх существующего бэкенда.",
        ],
    },
    definition: {
        term: "Что такое десктопное приложение?",
        text:
            "Десктопное приложение — программа, устанавливаемая на компьютер. Она напрямую работает с ресурсами операционной системы, локальными файлами и подключённым оборудованием и способна выполнять свои задачи без интернета.",
    },
    included: {
        eyebrow: "Что входит",
        h: "Что входит в каждый тариф по умолчанию",
        sub: "Это не услуги, которые доплачиваются потом — всё перечисленное есть и в базовом тарифе.",
        items: [
            "Бесплатная консультация и разбор текущего процесса",
            "Техническое задание и список функций",
            "Дизайн интерфейса в Figma под большой экран",
            "Единая кодовая база для Windows и macOS",
            "Локальная база данных и офлайн-режим",
            "Механизм синхронизации с сервером",
            "Система автоматического обновления",
            "Установочные файлы: .exe и .dmg",
            "Цифровая подпись кода для Windows и macOS",
            "Руководство пользователя и администратора",
            "Обучение сотрудников и помощь с переносом данных",
            "Git-репозиторий и полное владение кодом на вашей стороне",
        ],
    },
    benefits: {
        eyebrow: "Зачем нужно",
        h: "Что десктопное приложение даёт бизнесу",
        sub: "Это не замена сайту, а решение задач, с которыми браузер не справляется.",
        items: [
            {
                t: "Работает без интернета",
                d: "На кассе, складе и выездных объектах связь пропадает. Десктопное приложение пишет данные в локальную базу, а при восстановлении связи автоматически отправляет их на сервер. Работа не останавливается и ничего не теряется.",
            },
            {
                t: "Прямая связь с оборудованием",
                d: "Чековый принтер, фискальный модуль, весы, сканер штрих-кодов, RFID-считыватель, камера и устройства на портах COM и USB. В браузере большая часть этого недоступна или требует установки отдельной программы.",
            },
            {
                t: "Быстрая работа с тяжёлыми файлами",
                d: "Видео, чертежи CAD, крупные таблицы Excel и отчёты на сотни тысяч строк обрабатываются локальным процессором. Не нужно загружать файл в облако и ждать результата.",
            },
            {
                t: "Данные не покидают компанию",
                d: "База лежит на сервере компании или на компьютере сотрудника. Для банков, медицины и госсектора это часто требование, а не пожелание. Данные при этом могут вообще никуда не отправляться.",
            },
            {
                t: "Скорость работы с клавиатуры",
                d: "Для оператора, который вносит сотни записей за смену, скорость решает всё. Горячие клавиши, цифровой блок и быстрое переключение между окнами заметно сокращают время на операцию.",
            },
            {
                t: "Фоновые процессы без перерыва",
                d: "Приложение собирает отчёты, забирает данные из базы 1С, обрабатывает файлы или делает резервную копию, даже когда окно свёрнуто. А стоит закрыть вкладку браузера — и такие процессы останавливаются.",
            },
            {
                t: "Один код — три системы",
                d: "Electron или Tauri собирают из одной кодовой базы версии для Windows, macOS и Linux. Отдельная команда и отдельный бюджет под каждую платформу не требуются.",
            },
            {
                t: "Управляемые обновления",
                d: "Система автообновления сама доставляет новую версию, но когда её выпускать, решаете вы. Можно заморозить версию в горячий период или выкатить сборку только на одну группу для проверки.",
            },
        ],
    },
    audience: {
        eyebrow: "Кто заказывает",
        h: "Под какие задачи делают десктопное приложение",
        sub: "Случаи, где нужны оборудование, офлайн-режим или тяжёлые расчёты.",
        items: [
            {
                t: "Касса и точки продаж",
                d: "Печать чеков, фискальный модуль, весы и сканер, торговля при отсутствии интернета.",
            },
            {
                t: "Склад и инвентаризация",
                d: "Сканер штрих-кодов, приходные и расходные документы, офлайн-пересчёт и последующая синхронизация.",
            },
            {
                t: "Производство и лаборатория",
                d: "Сбор данных с оборудования, технологические карты, контроль качества и сменные отчёты.",
            },
            {
                t: "Бухгалтерия и финансы",
                d: "Обмен с базой 1С, большие отчёты, массовая печать документов и выгрузки.",
            },
            {
                t: "Проектирование и медиа",
                d: "Чертежи CAD, видеомонтаж и работа с крупными наборами изображений на локальном диске.",
            },
            {
                t: "Системы закрытого контура",
                d: "Программы для организаций, работающих без выхода в интернет или в ограниченной сети.",
            },
            {
                t: "Рабочее место оператора",
                d: "Интерфейс быстрого ввода с клавиатуры для колл-центра, диспетчера и регистратуры.",
            },
            {
                t: "Учебные и экзаменационные центры",
                d: "Программа тестирования: контролируемая сдача на компьютере, ограниченная сеть и защищённое хранение результатов.",
            },
        ],
    },
    pricing: {
        eyebrow: "Цены",
        h: "Стоимость десктопного приложения — три тарифа",
        sub: "Цена указана сразу за версии для Windows и macOS.",
        note:
            "Итоговая смета фиксируется после утверждения технического задания. Оплата идёт поэтапно. Сертификат для подписи кода (для Windows примерно 200–600 долларов в год, Apple Developer — 99 долларов в год) и серверные расходы оплачиваются провайдеру напрямую.",
        tiers: [
            {
                name: "Start",
                tagline: "Программа под одну конкретную задачу",
                price: "35 000 000",
                priceNote: "сум",
                term: "2–4 месяца",
                best: "Тем, кто автоматизирует один отдел или один процесс",
                features: [
                    "Windows и macOS из одного кода",
                    "Индивидуальный дизайн интерфейса",
                    "Локальная база данных (SQLite или PostgreSQL)",
                    "5–8 основных окон и рабочих сценариев",
                    "Экспорт в Excel и PDF, печать",
                    "Роли пользователей и права доступа",
                    "Система автоматического обновления",
                    "Установочные файлы и подпись кода",
                    "Руководство и 3 месяца поддержки",
                ],
            },
            {
                name: "Business",
                tagline: "Полная система с оборудованием и интеграциями",
                price: "70 000 000",
                priceNote: "сум",
                term: "4–7 месяцев",
                best: "Процессам с оборудованием: касса, склад, производство",
                featured: true,
                features: [
                    "Всё, что входит в тариф Start",
                    "Интеграция оборудования: принтер, фискальный модуль, весы, сканер",
                    "Полный офлайн-режим и синхронизация с сервером",
                    "Несколько рабочих мест и централизованное управление",
                    "Обмен данными с 1С, CRM или ERP",
                    "Веб-панель: отчёты для руководства в браузере",
                    "Сложные отчёты и аналитическая панель",
                    "Журнал действий (audit log) и резервное копирование",
                    "Обучение сотрудников и перенос данных из старой базы",
                    "Техническая документация и 6 месяцев поддержки",
                ],
            },
            {
                name: "Enterprise",
                tagline: "Для крупных систем и закрытого контура",
                price: "По договору",
                priceNote: "",
                term: "По проекту",
                best: "Компаниям с сетью филиалов, высокими требованиями к безопасности или особым оборудованием",
                features: [
                    "Сеть филиалов и централизованная репликация",
                    "Интеграция с Active Directory и единым входом (SSO)",
                    "Модули уровня драйверов под специфическое оборудование",
                    "Закрытый контур: работа без выхода в интернет",
                    "Локальные модели искусственного интеллекта на компьютере",
                    "Аудит безопасности и шифрование данных",
                    "Модель выделенной команды и согласованный SLA",
                    "Развёртывание внутри компании (on-premise) и мониторинг",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Процесс",
        h: "Как создаётся десктопное приложение",
        sub: "Работа делится на этапы, и в конце каждого вы видите результат.",
        steps: [
            {
                t: "Изучение процесса",
                d: "Смотрим на месте, как сотрудник работает сегодня: какой шаг съедает время, какие данные вводятся вручную, какое оборудование подключено. После этого пишется техническое задание.",
                time: "1–2 недели",
            },
            {
                t: "Технология и архитектура",
                d: "Выбираем Electron или Tauri, тип локальной базы, схему синхронизации и состав интеграций. Это решение напрямую влияет на скорость работы и бюджет проекта.",
                time: "1 неделя",
            },
            {
                t: "Дизайн интерфейса",
                d: "Окна рисуются в Figma. Десктопный интерфейс отличается от мобильного: данные размещаются плотнее, учитываются управление с клавиатуры и работа с несколькими окнами.",
                time: "2–4 недели",
            },
            {
                t: "Ядро и база данных",
                d: "Собираем структуру данных, серверный API и логику синхронизации. На этом этапе согласуются правила разрешения конфликтов, которые возникают при офлайн-работе.",
                time: "3–5 недель",
            },
            {
                t: "Разработка приложения",
                d: "Окна собираются по очереди, оборудование подключается и проверяется. Каждые 2–3 недели вы получаете установочную сборку и тестируете её на своём компьютере.",
                time: "6–14 недель",
            },
            {
                t: "Тестирование и подпись",
                d: "Проверяем на разных версиях Windows и macOS вместе с реальным оборудованием. Затем подписываем код сертификатом и проходим нотаризацию Apple для macOS.",
                time: "2–3 недели",
            },
            {
                t: "Внедрение и обучение",
                d: "Устанавливаем программу на рабочие места, переносим данные из старой базы, обучаем сотрудников и первые недели остаёмся на связи.",
                time: "1–3 недели",
            },
        ],
    },
    samples: {
        eyebrow: "Примеры",
        h: "Системы, которые мы построили",
        sub: "Бэкенд и логика данных в этих проектах строятся так же, как и для десктопного приложения.",
        cta: "Смотреть все проекты",
        slugs: ["elma-lms", "imtihan", "logistatrans", "firewise-app", "myyurist-app"],
    },
    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы о десктопных приложениях",
        sub: "Короткие ответы на то, что спрашивают чаще всего перед заказом.",
        items: [
            {
                q: "Сколько стоит разработка десктопного приложения?",
                a: "Цена начинается от 35 000 000 сум. В базовый тариф входят 5–8 окон, локальная база, роли, экспорт и автообновление. Если нужны интеграция оборудования, полный офлайн-режим и обмен с 1С, тариф начинается от 70 000 000 сум. Точная сумма фиксируется после утверждения технического задания.",
            },
            {
                q: "Нужно ли платить за Windows и macOS отдельно?",
                a: "Нет. Electron и Tauri собирают версии для обеих систем из одной кодовой базы, поэтому цена одна. Версия для Linux при необходимости собирается из того же кода. Разница есть только в тестировании и подписи, и на бюджет она влияет незначительно. Если вам нужен только Windows, версию для macOS можно убрать из плана и сократить срок.",
            },
            {
                q: "Мне нужно десктопное приложение или достаточно веб-версии?",
                a: "Если сотрудник может работать в браузере и оборудование не нужно, веб-приложение дешевле и удобнее: ничего не устанавливается, обновление происходит в одном месте. Десктоп выбирают, когда нужны работа без интернета, связь с принтером и сканером, обработка тяжёлых файлов или запрет на вынос данных.",
            },
            {
                q: "Чем отличаются Electron и Tauri?",
                a: "Electron построен на Chromium: экосистема большая, разработка идёт быстрее, но установочный файл занимает около 80–150 МБ. Tauri написан на Rust, размер падает до 10–20 МБ и памяти требуется меньше. Если у сотрудников много старых и слабых машин, советуем Tauri; если нужны сложные библиотеки — Electron.",
            },
            {
                q: "Как программа работает без интернета?",
                a: "Данные пишутся в локальную базу на компьютере, и приложение работает с ней. Когда связь восстанавливается, изменения по очереди уходят на сервер. Для записей, изменённых одновременно в двух местах, заранее согласуется правило разрешения конфликта, поэтому данные не теряются. Сотрудник при этом всегда видит в интерфейсе время последней синхронизации и число неотправленных записей.",
            },
            {
                q: "Можно ли подключить принтер, весы и сканер?",
                a: "Да, это главное преимущество десктопного приложения. Работаем с чековыми принтерами, фискальными модулями, электронными весами, сканерами штрих-кодов и устройствами на портах COM и USB. Если есть документация или SDK оборудования, интеграция проходит просто. Для редких устройств сначала проводим небольшой тест и только после него фиксируем срок — так не возникает неожиданных задержек в середине проекта.",
            },
            {
                q: "Как обновления доходят до компьютеров сотрудников?",
                a: "В приложение встраивается система автообновления: при запуске программа проверяет наличие новой версии и загружает её в фоне. Администратор контролирует, какая версия выпускается. То есть обходить каждое рабочее место и переустанавливать вручную не нужно. При необходимости обновление можно сначала выкатить на один отдел и проверить его там.",
            },
            {
                q: "Зачем нужна подпись кода?",
                a: "Неподписанную программу Windows SmartScreen и macOS Gatekeeper помечают как «неизвестный источник» или вовсе блокируют. Поэтому код подписывается цифровым сертификатом, а для macOS проходит нотаризацию Apple. Сертификат оформляется на вашу компанию, а техническую часть выполняем мы. Подписанная программа открывается у сотрудников с первого раза и без лишних предупреждений системы.",
            },
            {
                q: "Можно ли связать приложение с моей 1С или CRM?",
                a: "Да. Обмен с 1С обычно строится через файлы или веб-сервис, с CRM и ERP — через API. Данные могут ходить в обе стороны: программа забирает товары и цены, а возвращает продажи и документы движения. Объём интеграции определяется в рамках проекта.",
            },
            {
                q: "Есть ли поддержка после запуска?",
                a: "Да. В тариф Start входят 3 месяца поддержки, в Business — 6 месяцев. В этот период ошибки исправляются бесплатно, и мы отвечаем на вопросы сотрудников. Дальше предлагаем договор на ежемесячное обслуживание: адаптация под новые версии Windows и macOS, контроль резервных копий и небольшие доработки.",
            },
        ],
    },
    cta: {
        h: "Разберём ваш процесс вместе?",
        p: "На бесплатной консультации разберём задачу и честно скажем, нужно ли десктопное приложение или веб-версия закроет её дешевле. Затем пришлём техническое задание, точную цену и срок. Звоните: +998 90 954 12 62.",
        button: "Получить бесплатную консультацию",
        secondary: "Написать в Telegram",
    },
    images: [
        {
            src: "/assets/img/services/desktop-ilova-hero.webp",
            alt: "Интерфейс десктопного приложения для Windows и macOS на экране ноутбука",
            caption: "Из одной кодовой базы собираются установочные файлы для Windows и macOS.",
            prompt: "A clean modern desktop application interface shown on a laptop screen in a bright office, dense data table with sidebar navigation and toolbar, dark blue and white UI, photorealistic, wide angle, soft daylight, no text readable",
        },
        {
            src: "/assets/img/services/desktop-ilova-kassa.webp",
            alt: "Кассовая десктопная программа с подключённым чековым принтером и сканером",
            caption: "Рабочее место кассира: чековый принтер, фискальный модуль, весы и сканер в одной программе.",
            prompt: "Retail point of sale workstation: monitor with POS software, receipt printer printing, barcode scanner and electronic scale on the counter, shallow depth of field, realistic photo, warm store lighting",
        },
        {
            src: "/assets/img/services/desktop-ilova-oflayn.webp",
            alt: "Схема офлайн-работы складской программы и синхронизации данных с сервером",
            caption: "При обрыве связи данные пишутся в локальную базу, затем синхронизируются с сервером.",
            prompt: "Technical illustration of offline-first data sync: a desktop computer with a local database icon, dashed connection to a cloud server, sync arrows, flat vector style, blue and teal palette, minimal, clean background",
        },
        {
            src: "/assets/img/services/desktop-ilova-electron-tauri.webp",
            alt: "Сравнение технологий Electron и Tauri в архитектуре десктопного приложения",
            caption: "Electron или Tauri — выбор зависит от размера сборки и требований к памяти.",
            prompt: "Side by side comparison diagram of two desktop app frameworks, one box labeled heavier bundle and one labeled lighter bundle, with Windows and macOS device icons below, flat vector infographic, blue accent, clean white background",
        },
    ],
    related: ["veb-ilovalar", "mobil-ilova", "erp-tizimlar", "biznes-avtomatlashtirish", "crm-tizimlar"],
};

const content = { uz, ru };

export default content;
